import React, { useEffect, useState } from 'react';
import { CloseButton, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { formatGuatemalanDateTime } from '../../Utils/dateFormat';
import { loginRequest } from '../../authConfig';
import { NotificationsDataService } from '../../Services/NotificationsDataService';
import { useMsal } from '@azure/msal-react';
import './NotificationDropdown.scss';
import { formatDateTime } from '../../Utils/formaters';

const NotificationsDropdown = () => {
    const [notifications, setNotifications] = useState([]);
    const { instance, accounts, inProgress } = useMsal();

    useEffect(() => {
        fetchUnreadNotifications();
    }, []);

    const fetchUnreadNotifications = async () => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);

            const data = await NotificationsDataService.getUnreadNotifications(response.accessToken);
            setNotifications(data);
        } catch (error) {
            console.error('Failed to fetch unread notifications:', error);
        }
    };

    const markAsRead = async (notificationId) => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);

            await NotificationsDataService.markAsRead(notificationId, response.accessToken);
            fetchUnreadNotifications();
        } catch (error) {
            console.error('Failed to mark notification as read:', error);
        }
    };

    return (
        <Dropdown autoClose="outside" align="end">
            <Dropdown.Toggle className='notifications-icon text-dark' variant="" id="dropdown-basic">
            <FontAwesomeIcon icon={faBell} size='sm' />
                {notifications.length > 0 && (
                    <span className="translate-middle bg-danger rounded-circle alerts-indicator">
                    <span className="visually-hidden">New alerts</span>
                  </span>
                )}
            </Dropdown.Toggle>

            <Dropdown.Menu className='notification-dropdown-menu'>
            {notifications.length === 0 ? (
                    <Dropdown.ItemText>No unread notifications</Dropdown.ItemText>
                ) : (
                    notifications.map((notification, ix) => (
                        <Dropdown.ItemText key={notification.id} onClick={(e) => console.log(notification)}>
                            <div className=''>
                                <div className='d-flex justify-content-end'>
                                    <CloseButton onClick={() => markAsRead(notification.id)} />
                                </div>
                                <strong>{notification.title}</strong>
                                <p className='text-wrap'>
                                    {notification.message.length > 200
                                        ? `${notification.message.slice(0, 200)}...`
                                        : notification.message}
                                </p>
                                <small>{formatDateTime(notification.date)}</small>
                            </div>
                        </Dropdown.ItemText>
                    ))
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default NotificationsDropdown;
